import { AgTechButton, AgTechButtonProps } from "@agtech/web/components/Buttons/AgTechButtons";
import { AgTechForm } from "@agtech/web/components/Forms/AgTechForm";
import { AgTechFormTextControl } from "@agtech/web/components/Forms/Controls/AgTechFormTextControl";
import { AgTechFormRow } from "@agtech/web/components/Forms/Layout/AgTechFormRow";
import { useFormContext } from "@agtech/core/forms/AgTechFormContext";
import { useInvoiceDataDownloadSampleInvoiceRequest } from "@sales/data/invoicing/InvoicingDataQueries";
import { DefaultInvoiceDocumentConfiguration, InvoiceDocumentConfiguration } from "@sales/data/operation/SaleDataOperation";
import { useOperationDataUpdateInvoiceDocumentConfigurationAction } from "@sales/data/operation/SaleDataOperationActions";
import { useRef } from "react";

export type InvoiceDocumentConfigurationFormProps = {
    config?: InvoiceDocumentConfiguration
};

const InvoiceDocumentConfigurationForm = (props: InvoiceDocumentConfigurationFormProps) => {

    var configData = {
        ...DefaultInvoiceDocumentConfiguration,
        ...props.config
    };

    let invoiceConfigurationSubmission = useOperationDataUpdateInvoiceDocumentConfigurationAction();
    let submitButton = useRef<{ click: () => Promise<void> }>({ click: async () => {} });

    return (
        <AgTechForm
            structure={{
                header: {
                    title: 'Invoice Configuration',
                    content: () => (
                        <>
                            <div id='settings-invoice-sample'>
                                <GenerateSampleInvoiceButton classes='highlight' />
                            </div>
                            <div id='settings-invoice-save'>
                                <InvoiceSaveButton onSave={() => submitButton.current?.click()} />
                            </div>
                        </>
                    )
                },
                submitButton: submitButton
            }}
            initialFormData={configData}
            action={{
                action: invoiceConfigurationSubmission,
                getActionData: d => d
            }}
        >
            <div id='settings-invoice-labels'>
            <AgTechFormRow>
                <AgTechFormTextControl
                    entityType={configData}
                    caption="Item # Text"
                    focused={true}
                    value={entity => entity.itemNumberText ?? ''}
                    onControlValueChanged={async (e, val) => ({
                        ...e,
                        itemNumberText: val
                    })}
                />
                <AgTechFormTextControl
                    entityType={configData}
                    caption="Purchase Price Text"
                    value={entity => entity.purchasePriceText ?? ''}
                    onControlValueChanged={async (e, val) => ({
                        ...e,
                        purchasePriceText: val
                    })}
                />
                <AgTechFormTextControl
                    entityType={configData}
                    caption="Checks Payable Text"
                    value={entity => entity.checksPayableText ?? ''}
                    onControlValueChanged={async (e, val) => ({
                        ...e,
                        checksPayableText: val
                    })}
                />
            </AgTechFormRow>
            </div>
            <div id='settings-invoice-description'>
            <AgTechFormRow>
                <AgTechFormTextControl
                    entityType={configData}
                    caption="Description Text"
                    value={entity => entity.descriptionText ?? ''}
                    width={100}
                    onControlValueChanged={async (e, val) => ({
                        ...e,
                        descriptionText: val
                    })}
                />
            </AgTechFormRow>
            </div>
            <div id='settings-invoice-thanks'>
            <AgTechFormRow>
                <AgTechFormTextControl
                    entityType={configData}
                    caption="Thank You Text"
                    value={entity => entity.thanksText ?? ''}
                    width={100}
                    onControlValueChanged={async (e, val) => ({
                        ...e,
                        thanksText: val
                    })}
                />
            </AgTechFormRow>
            </div>
        </AgTechForm>
    )
}

const InvoiceSaveButton = (props: { onSave: () => void }) => {
    let { isDirty } = useFormContext();

    return (
        <AgTechButton
            text='Save'
            icon='fas fa-save'
            classes='button-highlight px-4 ml-2'
            disableIf={!isDirty}
            action={props.onSave}
        />
    );
}

const GenerateSampleInvoiceButton = (props: AgTechButtonProps) => {
    let sampleInvoiceRequest = useInvoiceDataDownloadSampleInvoiceRequest();
    
    let buttonProps: AgTechButtonProps = {
        text: "Download Sample Invoice",
        icon: 'fas fa-download',
        ...props,
        action: async () => {
            await sampleInvoiceRequest.execute({
                data: undefined
            });
        }
    };

    return <AgTechButton {...buttonProps} />
}

export default InvoiceDocumentConfigurationForm